export default __webpack_public_path__ + "static/media/WicandersBackground.5839630e.jpg";